/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ComponentProvider } from '@angular-kit/view';
import { TimeRecordingComponentKey } from './key/time-recording-component.key';
import { TimeRecordingSidebarComponent } from './component/time-recording-sidebar/time-recording-sidebar.component';

import { DeviceInitializer, TimeRecordingInitializer as GlobalTimeRecordingInitializer } from '@teamworks/global';
import { ProjectInputComponent } from './component/project-input/project-input.component';
import { ProjectAutoCompleteInputComponent } from './component/project-auto-complete-input/project-auto-complete-input.component';

export class TimeRecordingInitializer {

  static initialize() {
    GlobalTimeRecordingInitializer.initialize();
    DeviceInitializer.initialize();
    TimeRecordingInitializer.registerComponents();
  }

  static registerComponents() {
    ComponentProvider.registerComponentType(TimeRecordingComponentKey.TIME_RECORDING_SIDEBAR, TimeRecordingSidebarComponent);
    ComponentProvider.registerComponentType(TimeRecordingComponentKey.PROJECT_INPUT, ProjectInputComponent);
    ComponentProvider.registerComponentType(TimeRecordingComponentKey.PROJECT_AUTO_COMPLETE_INPUT, ProjectAutoCompleteInputComponent);
  }

}
